

module.exports = {
    component: require('../not-found/NotFound')
};



// WEBPACK FOOTER //
// ./src/app/components/index/route.MicroSitesIndex.js